import React from 'react';

import logo from 'assets/images/logo-white.svg';
import calendar from 'assets/images/icons/calendar.svg';
import dashboard from 'assets/images/icons/dashboard.svg';
import person from 'assets/images/icons/person.svg';
import statistics from 'assets/images/icons/statistics.svg';
import settings from 'assets/images/icons/settings.svg';
import partners from 'assets/images/icons/partners.svg';
import logout from 'assets/images/icons/logout.svg';

import './Sidebar.scss';

import { Button } from 'components/Button/Button';
import { Link } from 'react-router-dom';
import { useSidebarVM } from './useSidebarVM';

export type SidebarItemsType = {
    label: string;
    iconSrc: string;
    url: string;
    hasNoOverflow?: boolean;
    isManager?: boolean;
};

export const sidebarItems: SidebarItemsType[] = [
    {
        label: 'Tableau de bord',
        iconSrc: dashboard,
        url: '/app/admin'
    },
    {
        label: 'Personnes soutenues',
        iconSrc: person,
        url: '/app/admin/persons'
    },
    {
        label: 'Agenda',
        iconSrc: calendar,
        url: '/app/admin/calendar'
    },
    {
        label: 'Partenaires',
        iconSrc: partners,
        url: '/app/admin/partners'
    },
    {
        label: 'Statistiques',
        iconSrc: statistics,
        isManager: true,
        url: '/app/admin/statistics'
    },
    {
        label: 'Réglages',
        iconSrc: settings,
        url: '/app/admin/settings'
    }
];

export const Sidebar: React.FC = () => {
    const { selectedItem, handleLogout, user } = useSidebarVM();

    return (
        <div className="sidebar">
            <div className="sidebar-wrapper">
                <img src={logo} className="logo" alt="logo" />


                <div className="user-infos">
                    <p className="hi">Bonjour</p>
                    <p className="username">{user?.fullname}</p>
                </div>
        

                <div className="separator"></div>

                <div className="links">
                    {sidebarItems.filter((item) => !item.isManager || user?.role === 'admin' || user?.role === 'manager').map(({ label, iconSrc, url, hasNoOverflow }: SidebarItemsType, index: number) => (
                        <Link
                            key={index}
                            to={url}
                            className={`${hasNoOverflow ? 'no-overflow' : ''}${selectedItem === index ? 'selected' : ''}`}
                        >
                            <img src={iconSrc} alt={label} />
                            <span>{label}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};
